export enum IssueSeverity {
  CRITICAL = 'Critical',
  WARNING = 'Warning',
  INFO = 'Info',
}

export interface Issue {
  id: string;
  severity: IssueSeverity;
  element: string;
  description: string;
  suggestion: string;
  lineNumber?: number;
}

export interface TagStats {
  semantic: number;
  generic: number;
  total: number;
}

export interface HeadingNode {
  tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  text: string;
  skipped?: boolean;
}

export interface MetaCoverage {
  viewport: boolean;
  canonical: boolean;
  description: boolean;
  openGraph: boolean;
  twitterCard: boolean;
}

export interface RenderDiff {
  ssrAvailable: boolean;
  ssrSize: number;
  csrSize: number;
  schemaTypesAddedByJs: string[];
  schemaTypesRemovedByJs: string[];
  h1AddedByJs: boolean;
  titleAddedByJs: boolean;
  headingsCountSsr: number;
  headingsCountCsr: number;
  metaAddedByJs: {
    viewport: boolean;
    canonical: boolean;
    description: boolean;
    openGraph: boolean;
    twitterCard: boolean;
  };
}

export interface AnalysisResult {
  score: number;
  summary: string;
  semanticRatio: number;
  tagStats: TagStats;
  issues: Issue[];
  positiveHighlights: string[];
  headingHierarchy: HeadingNode[];
  schemaTypes: string[];
  imagesWithoutAlt: number;
  imagesTotal: number;
  metaCoverage: MetaCoverage;
  textHtmlRatio: number;
  renderDiff?: RenderDiff;
  sourceUrl?: string;
  sourceTitle?: string;
}

export type AnalyzeStatus = 'idle' | 'scraping' | 'analyzing' | 'complete' | 'error' | 'rate-limited';

export interface RateLimitInfo {
  scope: 'burst' | 'daily' | 'global' | 'blocked';
  message: string;
  /** Unix ms when the limit resets */
  resetAt: number;
}

export interface AppState {
  status: AnalyzeStatus;
  result: AnalysisResult | null;
  error: string | null;
  rateLimit: RateLimitInfo | null;
  /** Cached CSR HTML from the last URL analysis, used for client-side re-diff
   *  when the user pastes their own SSR view */
  lastCsrHtml: string | null;
}
